import UNIQUE from '@/common/unique'
import columnDetail from '../columnDetail'
export default {
  id: 'smartvoice',
  name: 'smartvoice',
  type: 'standard',
  moduleName: 'editor_module_smartvoice',
  dataSet: {
    mods: 'flexible',
    column: [
      {
        columnId: UNIQUE.mid(),
        flex: 1,
        type: 'smartvoice',
        value: null,
        detail: {
          options: ['smartvoice', 'colorHex', 'border', 'background', 'padding', 'radius'],
          smartvoice: columnDetail.smartvoice,
          colorHex: columnDetail.colorHex,
          border: columnDetail.border,
          background: columnDetail.background,
          padding: columnDetail.padding,
          radius: columnDetail.radius
        }
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'link',
        'columns',
        'background',
        'border',
        'text',
        'padding'
      ]
    },
    action: null,
    detail: {}
  }
}
